<template>
  <a-drawer
    title="Filters"
    placement="right"
    :width="SizeDevice ? '90%': 400"
    :visible="visible_drawer"
    @close="visible_drawer = false"
    :bodyStyle="{marginBottom:'3em'}"
    keyboard
  >
    <a-form :form="form" @submit.prevent="handleFilter">
      <slot></slot>
      <a-button type="primary" ghost @click="resetForm" class="mt-5" style="border-radius: 3px !important;">Reset Filter</a-button>
    </a-form>
  </a-drawer>
</template>

<script>
export default {
  name: "Drawer",
  props:{
    ele:{
      type:Object,
      required: false
    },
    query:{
      type: Array,
      required: true
    },
    form:{
      type: Object,
      required: true
    }
  },
  data(){
    return{
      visible_drawer : false,
      windowWidth    : window.innerWidth
    }
  },
  methods:{
    checkPagination(ref){
      ref.query.search = undefined
      ref.search_tbl = null
      const tbl_length = ref.data.length
      if(tbl_length <= 5 || tbl_length <= 10 || tbl_length <= 20) ref.query.page = 1
    },
    handleFilter(){
      this.form.validateFields(async (err, values) => {
            try{
              this.visible_drawer = false
              this.ele.loading = true
              const filter = this.query.filter(item => Array.isArray(item.value) ? item.value.length : item.value)
              .map(item => ({
                operation : item.field !== 'title' ? 'and' : undefined,
                condition : item.condition,
                field     : item.field,
                value     : item.value
              }))
              this.ele.query.query = filter
              this.checkPagination(this.ele)
              await this.ele.fetch()
              this.$emit('filter')
            }catch (e){
              throw e
            }finally {
              this.ele.loading = false
            }
        })
    },
    resetForm() {
      this.form.resetFields()
    }
  },

  computed:{
    SizeDevice(){
      return this.windowWidth < 600
    },
  },

  mounted() {
    window.addEventListener('resize', () => this.windowWidth  = window.innerWidth)
  }

}
</script>

<style scoped>

</style>
